import { ICreateAndUpdateArea } from "../../../types/area.interface";
import customAxios from "../../customAxios";
import { CREATE_AREA } from "../../routes";

const createArea = async (props: ICreateAndUpdateArea) => {
  const body = {
    ...props,
  };

  try {
    return (await customAxios.post(CREATE_AREA, body)).data;
  } catch (error: unknown) {
    console.error({ CREATE_AREA: error });
    return false;
  }
};

export default createArea;
